<template>
  <div id="file-drag-drop">
    <input class="input-file" type="file" ref="file" @change="handleFileChange" multiple/>
    <form class="file-uploader" ref="fileform">
      <div class="file-button" @click="$refs.file.click()">
        <span class="drop-files">{{texto}}</span>
      </div>
      <div v-for="(file, key) in files" v-bind:key="key" class="file-listing">
        <span @click="removeFile(key)" class="remove-file">
          <v-icon>clear</v-icon>
        </span>
        <img :key="file.id" class="preview" :src="file.base64" v-if="file.tipo==='imagen' && file.base64"/>
        <span class="extension" v-if="file.tipo !== 'imagen'">{{ file.extension }}</span>
        <span class="filename">{{ file.name }}</span>
      </div>
    </form>
  </div>
</template>
<script>
window.addEventListener('dragover', function (e) {
  e = e || event;
  e.preventDefault();
}, false);
window.addEventListener('drop', function (e) {
  e = e || event;
  e.preventDefault();
}, false);
export default {
  props: {
    exito: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: 'Arrastra tus archivos aquí'
    },
    dragover: {
      type: String,
      default: 'Suelta acá!'
    },
    maxFiles: {
      type: Number,
      default: 1
    },
    textoMaxFiles: {
      type: String,
      default: 'Sólo puede adjuntar # archivos!'
    },
    types: {
      type: Array,
      default: function () { return []; }
    },
    options: {
      type: Object,
      default: function () { return {}; }
    }
  },
  data () {
    return {
      texto: 'Arrastra tus archivos aca!',
      dragAndDropCapable: false,
      files: []
    };
  },
  created () {
    if (this.options) {
      if (this.options.hasOwnProperty('url')) this.url = this.options.url;
      if (this.options.hasOwnProperty('label')) this.label = this.options.label;
      if (this.options.hasOwnProperty('dragover')) this.dragover = this.options.dragover;
      if (this.options.hasOwnProperty('textoMaxFiles')) this.textoMaxFiles = this.options.textoMaxFiles;
      if (this.options.hasOwnProperty('texto-max-files')) this.textoMaxFiles = this.options['texto-max-files'];
      if (this.options.hasOwnProperty('maxFiles')) this.maxFiles = this.options.maxFiles;
      if (this.options.hasOwnProperty('max-files')) this.maxFiles = this.options['max-files'];
      if (this.options.hasOwnProperty('types')) this.maxFiles = this.options['types'];
    }
  },
  watch: {
    exito () {
      if (this.exito) {
        this.files = [];
      }
    },
    files () {}
  },
  mounted () {
    this.dragAndDropCapable = this.determineDragAndDropCapable();
    if (this.dragAndDropCapable) {
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
        this.$refs.fileform.addEventListener(evt, function (e) {
          e.preventDefault();
          e.stopPropagation();
        }, false);
      }.bind(this), false);
      // }.bind(this));
      this.$refs.fileform.addEventListener('dragleave', function (e) {
        this.texto = this.label;
        this.$refs.fileform.style.border = '3px solid #DDD';
      }.bind(this));
      this.$refs.fileform.addEventListener('dragover', function (e) {
        this.texto = this.dragover;
        this.$refs.fileform.style.border = '3px solid #999';
      }.bind(this));
      this.$refs.fileform.addEventListener('drop', function (e) {
        for (let i = 0; i < e.dataTransfer.files.length; i++) {
          let objeto = e.dataTransfer.files[i];
          objeto.tipo = 'archivo';
          objeto.base64 = null;
          objeto.estado = 'pendiente';
          objeto.extension = objeto.name.split('.').pop().toLowerCase();
          objeto.nombre = objeto.name;
          objeto.id = i + '_' + objeto.estado;
          if (this.files.length < this.maxFiles) {
            if (this.types.length === 0 || this.types.indexOf(objeto.extension) !== -1) {
              this.files.push(objeto);
            }
          } else {
            this.$message.error(`${this.textoMaxFiles.replace('#', this.maxFiles)}`, null, { timeout: 2000 });
            break;
          }
        }
        this.getImagePreviews();
        this.texto = this.label;
        this.$refs.fileform.style.border = '3px solid #DDD';
        this.$emit('recuperar', this.files);
      }.bind(this));
    }
  },
  components: {},
  methods: {
    handleFileChange (e) {
      // this.$emit('input', e.target.files[0])
      for (let i = 0; i < e.target.files.length; i++) {
        let objeto = e.target.files[i];
        objeto.tipo = 'archivo';
        objeto.base64 = null;
        objeto.estado = 'pendiente';
        objeto.extension = objeto.name.split('.').pop().toLowerCase();
        objeto.nombre = objeto.name;
        objeto.id = i + '_' + objeto.estado;
        if (this.files.length < this.maxFiles) {
          if (this.types.length === 0 || this.types.indexOf(objeto.extension) !== -1) {
            this.files.push(objeto);
          }
        } else {
          this.$message.error(`${this.textoMaxFiles.replace('#', this.maxFiles)}`, null, { timeout: 2000 });
          break;
        }
      };
      this.getImagePreviews();
      this.$emit('recuperar', this.files);
    },
    determineDragAndDropCapable () {
      var div = document.createElement('div');
      return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window;
    },
    getImagePreviews () {
      for (let i = 0; i < this.files.length; i++) {
        this.leerArchivo(i);
      }
    },
    leerArchivo (i) {
      if (this.files[i].estado === 'pendiente') {
        this.files[i].estado = 'en proceso';
        this.files[i].id = i + '_' + this.files[i].estado;
        let reader = new FileReader();
        reader.addEventListener('load', function (event) {
          this.files[i].base64 = reader.result;
          this.files[i].estado = 'terminado';
          this.files[i].id = i + '_' + this.files[i].estado;
          if (/\.(jpe?g|png|gif|svg)$/i.test(this.files[i].name)) {
            this.files[i].tipo = 'imagen';
          }
          this.files.push({});
          this.files.pop();
        }.bind(this), false);
        reader.readAsDataURL(this.files[i]);
      }
    },
    removeFile (key) {
      let nuevo = [];
      for (let i = 0; i < this.files.length; i++) {
        if (i !== key) {
          nuevo.push(this.files[i]);
        }
      }
      this.files = nuevo;
      this.$emit('recuperar', this.files);
    },
    submitFiles () {
      let formData = new FormData();
      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i];

        formData.append('files[' + i + ']', file);
      }
    }
  }
};
</script>

<style lang="scss">
.input-file{
  display:none;
}
.file-button{
  background: transparent;
  position: absolute;
  cursor:pointer;
  width:100%;
  height:100%;
  left:0;
  top:0;
}
.file-uploader{
  display: block;
  height: 160px;
  width: 100%;
  background: #ebebeb;
  margin: auto;
  text-align: center;
  border-radius: 4px;
  position: relative;
  border: 3px solid #ddd;
  overflow: auto;
}
.drop-files{
  right:0;
  left:0;
  margin-top:50px;
  position: absolute;
  display: block;
  font-size: 20px;
  color: #999;
  text-align: center;
}
.file-listing{
  position:relative;
  background: #ebebeb;
  display: inline-block;
  height: 130px;
  width: 150px;
  padding: 10px;
  overflow: hidden;
  margin:2px;
  border: 2px solid #fff;
  font-size: 12px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;

  img{
    max-height:100px;
    max-width:120px;
  }
  .remove-file{
    position: absolute;
    right:5px;
    top: 5px;
    cursor:pointer;
    z-index: 1;
    :hover{
      color:#000;
    }
  }
  .extension{
    position:absolute;
    top:5px;
    left:0;
    right:0;
    text-align: center;
    font-size:40px;
    color:#ccc;
    text-transform: uppercase;
  }
  .filename{
    position:absolute;
    bottom:0;
    left:0;
    right:0;
    text-align: center;
    background: #999;
    padding:2px;
    height: 40px;
  }
}
.file-listing:hover{
  border-color:#666;
  cursor:move;
}

</style>



// WEBPACK FOOTER //
// src/common/plugins/file/Upload.vue